





































import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
import { Patient, Sex } from "../../../domain/patient";
import { IConfiguration } from "../../../domain/configuration";
import { ModelEditableMixin } from "../../system";
import { DomainRegistry } from "../../../domain";
import { DateFormatter } from "../../../domain/system";

@Component({
})
export default class PatientByNameFinder extends Mixins(ModelEditableMixin) {
  data(): any {
    return {
      edittingName: this.patientName ? this.patientName : "",
      selectedPatient: null as Patient,
      patients: [] as Patient[],
      isFinding: false,
      isSyncing: false,
    };
  }
  edittingName: string;
  selectedPatient: Patient;
  patients: Patient[];
  isFinding: boolean;
  isSyncing: boolean;

  @Prop()
  patientName: string;

  @Prop({ default: 1000 })
  maxCount: number;

  @Watch("patientName")
  onPatientFinderPatientNameUpdated(newValue: string, oldValue: string) {
    this.clearPatient();
    this.edittingName = newValue ? newValue : "";
  }

  get isFound(): boolean {
    return !this.isFinding && !!this.patients.length;
  }

  onEnterKeyDown(event: KeyboardEvent): void {
    if (event.keyCode !== 13) { return; }
    this.findPatient();
  }

  findPatient(): void {
    if (!this.edittingName) {
      this.$warn("入力チェック", "患者名を入力してください。");
      return;
    }
    this.isFinding = true;
    this.selectedPatient = null;
    this.patients = [];
    const repository = DomainRegistry.patient.getPatientRepository();
    repository.serachByName(this.edittingName)
      .then(patients => {
        if (patients.length === 0) {
          this.$warn("患者検索", "検索結果が0件でした。");
          return;
        }
        if (patients.length > this.maxCount) {
          this.$warn("患者検索", "検索結果が" + this.maxCount + "件を越えています。");
          return;
        }
        if (patients.length === 1) {
          this.selectedPatient = patients[0];
        }
        if (this.selectedPatient && !this.shouldConfirmFoundPatient) {
          // 一覧を表示しないで確定
          this.selectPatient();
          return;
        }
        this.patients = patients;
      })
      .catch(e => {
        console.error(e);
        this.clearPatient();
        this.$warn(
          "患者検索",
          "検索中にエラーが発生しました。",
          e,
        );
      }).finally(() => {
        this.isFinding = false;
      });
  }

  clearPatient(): void {
    this.selectedPatient = null;
    this.patients = [];
  }

  selectPatient(): void {
    if (!this.selectedPatient) {
      this.$warn("患者選択", "患者が選択されていません。");
      return;
    }
    // SyncPatientを叩く必要があるので、取得しなおす
    this.isSyncing = true;
    const repository = DomainRegistry.patient.getPatientRepository();
    repository.getEntity(this.selectedPatient.id)
    .then(p => {
      this.isSyncing = false;
      this.editingSource = p;
      this.clearPatient();
    }).catch(e => {
      this.isSyncing = false;
      this.clearPatient();
      this.$warn("患者名不正", "該当する患者が見つかりませんでした。", e);
    });
  }
  
  mounted() {
    this.focusToPatientName();
  }

  focusToPatientName(): void {
    const element = this.$refs.patientName as HTMLInputElement;
    element.focus();
    element.select();
  }

  get shouldConfirmFoundPatient(): boolean {
    const config = this.$store.getters.configuration as IConfiguration;
    return config.behavior.patient.finder.shouldConfirmFoundPatient;
  }

  onRowClicked(row: Patient): void {
    this.selectedPatient = row;
  }

  onRowDoubleClicked(row: Patient): void {
    this.selectedPatient = row;
    this.selectPatient();
  }

  toBirthDayText(value: Date): string {
    return value
      ? DateFormatter.format(value, "YYYY($JJJ$$Y$)年MM月DD日") + "生"
      : "";
  }

  toSexText(value: Sex): string {
    switch (value) {
      case Sex.Male: return "男性";
      case Sex.Female: return "女性";
    }
    return "性別不明";
  }
}
